export const stateFilter = [
    {
        value: "NEW",
        label: "Neuf",
    },
    {
        value: "USED",
        label: "Seconde main",
    }
]

export const sizeFilter = [
    {
        value: "XS",
        label: "XS",
    },
    {
        value: "S",
        label: "S",
    },
    {
        value: "M",
        label: "M",
    },
    {
        value: "L",
        label: "L",
    },
    {
        value: "XL",
        label: "XL",
    },
    {
        value: "XXL",
        label: "XXL",
    },
]

export const sortFilter = [
    {
        value: "price_asc",
        label: "Par prix croissant",
    },
    {
        value: "price_desc",
        label: "Par prix décroissant",
    },
    {
        value: "new_asc",
        label: "Les plus récents",
    },
    {
        value: "new_desc",
        label: "Les plus anciens",
    }
]